export default __webpack_public_path__ + "static/media/monitoreo.59dc685d.png";